module.exports = __webpack_public_path__ + "static/media/Geotechnical Engineering-I.83993fad.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CE/Geotechnical Engineering-I.pdf
// module id = 95
// module chunks = 0